import { render, staticRenderFns } from "./ListMajor.vue?vue&type=template&id=44b4bb37"
import script from "./ListMajor.vue?vue&type=script&lang=js"
export * from "./ListMajor.vue?vue&type=script&lang=js"
import style0 from "./ListMajor.vue?vue&type=style&index=0&id=44b4bb37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Section: require('/app/nuxt/components/Section.vue').default})
